import React, { useState } from "react";
import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
import { Box, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CustomGridToolbar from "../../../../components/datagrid/GridToolBar";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";

const OptionTerms = ({ data }) => {
  const [gridSize, setGridSize] = useState(10);
  const [open, setOpen] = useState(false);
  const TableHead = [
    {
      field: "serialNumber",
      headerName: "SlNo",
      width: 60,
    },
    {
      field: "term",
      headerName: "terms",
      width: 160,
    },
    {
      field: "InrTerm",
      headerName: "InrTerm",
      width: 250,
    },
    {
      field: "AedTerm",
      headerName: "AedTerm",
      width: 250,
      //   renderCell: (params) => {},
    },
  ];
  return (
    <GlobalDialog
      title={"Terms"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      maxWidth={"md"}
      fullWidth
      popupButton={
        <Button
          sx={{
            color: "white",
            background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
            borderRadius: 4,
          }}
          size="small"
          onClick={() => setOpen(true)}
        >
          Check Terms
        </Button>
      }
      content={
        <Box>
          {open ? (
            <GlobalWrapper>
              <DataGrid
                components={{ Toolbar: CustomGridToolbar }}
                rows={data?.map((list, index) => ({
                  ...list,
                  serialNumber: index + 1,
                  term: `Term ${index + 1}`,
                }))}
                columns={TableHead}
                // loading={loading}
                getRowId={(row) => row.serialNumber}
                pageSize={gridSize}
                autoHeight
                rowsPerPageOptions={[5, 10, 25, 50]}
                onPageSizeChange={(newGridSize) => setGridSize(newGridSize)}
              />
            </GlobalWrapper>
          ) : null}
        </Box>
      }
    />
  );
};

export default OptionTerms;
